import React, { useMemo } from "react";

import { Field, Inputs, Row } from "2g-form";

import { useTypyZdroje } from "b2b/api/hooks";
import { useServerMessage } from "b2b/i18n";
import useMessages from "./i18n/useMessages";

export function TypyZdrojuOnlySwitch(props = {}) {
  const { data } = useTypyZdroje();
  const typyZdroju = useMemo(() => data?.map(item => item.typZdroje), [data]);
  const message = useServerMessage();
  const { typyZdrojuLabel } = useMessages();
  return !typyZdroju ? null : (
    <Row asGroup>
      <Field
        dataId="name"
        items={typyZdroju}
        label={typyZdrojuLabel()}
        component={Inputs.RadioGroup}
        asSwitch
        path="typZdroje"
        content={({ data }) => message(data, "vyznam")}
        {...props}
      />
    </Row>
  );
}

TypyZdrojuOnlySwitch.propTypes = {};

export default React.memo(TypyZdrojuOnlySwitch);
